import { NotifBell } from '@components/NotifBell/NotifBell';
import { UploadStatus } from '@components/UploadStatus/UploadStatus';
import { useIsMobile } from '@lib/hooks/sizing/useIsMobile';
import { debugStore } from '@stores/Debug';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import css from './PageHeader.module.scss';

export const PageHeader = observer(
  ({
    children,
    noUser,
    floating,
  }: {
    children: React.ReactNode;
    noUser?: boolean;
    /** Float the chrome (upload / notifs) top-right over the content and drop the
     *  title, so the header reserves no vertical space. */
    floating?: boolean;
  }) => {
    const title = typeof children === 'string' ? <h1>{children}</h1> : children;
    const isMobile = useIsMobile();

    return (
      <div className={classNames(css.pageHeader, floating && css.floating)}>
        {!floating && <div className={css.leftSide}>{title}</div>}
        {/* Desktop only: the two separate popover triggers. On mobile these are
            replaced by the single bell FAB + unified drawer, mounted at the app
            shell root (MobileNotifCenter in App.tsx) so its fixed positioning
            isn't trapped by a page's transformed/blurred ancestors. */}
        {!noUser && !isMobile && (
          <div className={css.rightSide}>
            {debugStore.showUploadStatus && <UploadStatus />}
            <NotifBell />
          </div>
        )}
      </div>
    );
  },
);
